module.exports = __webpack_public_path__ + "static/media/icon_setting_on.ab416f9b.svg";